<template>
  <section class="preview">
    <form class="form" novalidate @submit.prevent="crear">
      <!-- Styled -->
        <mdb-input
            placeholder="Nombre"
            class="mb-3 mt-0"
            v-model="name"
            required
            invalidFeedback="Coloca el nombre"
        >
            <span class="input-group-text md-addon" slot="prepend">Nombre de estado</span>
        </mdb-input>

        <mdb-input
            placeholder="Nombre"
            class="mb-3 mt-0"
            v-model="code_state"
            required
            invalidFeedback="Coloca el nombre"
        >
            <span class="input-group-text md-addon" slot="prepend">Código de estado</span>
        </mdb-input>

        <div class="form-group">
            <label class="typo__label">País</label>
            <multiselect
            v-model="selectedCountry"
            placeholder="Seleccione el País"
            label="name"
            track-by="id"
            :options="countries"
            :multiple="false"
            :taggable="false"
            ></multiselect>
        </div>

        <!--<div class="form-group">
            <label class="typo__label">Códigos postales</label>
            <multiselect
            v-model="codPostalesSelected"
            :options="codPostales"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            placeholder="Selecciona codigos"
            label="name"
            track-by="id"
            :preselect-first="false"
            >
            
            </multiselect>-->
        </div>
      </div>

      <div class="text-center">
        <mdb-btn type="submit" color="primary" :disabled="isLoading">
          <span v-if="!isLoading">Crear</span>
          <semipolar-spinner :animation-duration="2000" :size="30" color="#ffffff" v-if="isLoading"></semipolar-spinner>
        </mdb-btn>
      </div>
    </form>
  </section>
</template>

<script>
import Multiselect from "vue-multiselect";
import { SemipolarSpinner } from "epic-spinners";
import {
  mdbContainer,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalFooter,
  mdbRow,
  mdbBtn,
  mdbIcon,
  mdbTextarea,
  mdbInput,
  mdbTooltip
} from "mdbvue";
import store from "../../store";
export default {
  name: "modal-1",
  components: {
    mdbInput,
    mdbBtn,
    SemipolarSpinner,
    Multiselect,
    mdbContainer,
    mdbModal,
    mdbModalBody,
    mdbModalTitle,
    mdbModalHeader,
    mdbModalFooter,
    mdbRow,
    mdbIcon,
    mdbTextarea,
    mdbTooltip
  },
  props: {
    onClick: Function
  },
  data: () => {
    return {
      isLoading: false,
      modal: false,
      name: "",
      code_state:"",
      selectedCountry: {},
      countries: [
      ],
      codPostalesSelected: [],
      codPostales: [],
      isLoadingLine: false
    };
  },
  async mounted() {
    var respuesta = await this.getCountries();
    respuesta = await this.getCodPostales();
  },
  methods: {
    async getCountries() {
      var countries = store.getters.getCountries;
      if (countries.length == 0) {
      
        await store.dispatch("getCountries").then(() => {
          var countryArray =[];
          countries = store.getters.getCountries;
          countries.map(i=>{
            var retorno={
              id:i.id,
              label: i.name,
              code:i.code,
              children:null
            }
            countryArray.push(retorno)
            return i;
          })
        this.countries = countries;
          return;
        });
      } else {
         var countryArray =[];
          countries = store.getters.getCountries;
          countries.map(i=>{
            var retorno={
             id:i.id,
              label: i.name,
              code:i.code,
              children:null
            }
            countryArray.push(retorno)
            return i;
          })
        this.countries = countries;
        return;
      }
    },
    async getCodPostales() {
      var codPostales = store.getters.getCodPostales;
      if (codPostales.length == 0) {
        this.isLoading = true;
        await store.dispatch("getCodPostales").then(() => {
          codPostales = store.getters.getCodPostales;
          this.isLoading = false;
          this.codPostales = codPostales;
        });
      } else {
        this.codPostales = codPostales;
      }
    },
    crear(event) {
      event.target.classList.add("was-validated");
      var {
        name,
        code_state,
        selectedCountry,
      } = this;
      this.isLoading = true;
      if (
        name == "" ||
        code_state == "" ||
        selectedCountry.length == 0
      ) {
        this.isLoading = false;
      } else {
        var country_id = selectedCountry.id
        var provincia = {
          name,
          country_id,
          code_state,
          selectedCountry
        };
        store.dispatch("newProvincia", provincia).then(() => {
          this.name = "";
          this.code_state = "";
          this.selectedCountry = {};
          this.onClick();
          this.isLoading = false;
        });
      }
    },
    crearLine(event) {
      event.target.classList.add("was-validated");
      var { nameLine, descriptionLine } = this;
      this.isLoadingLine = true;
      if (nameLine == "" || descriptionLine == "") {
        this.isLoadingLine = false;
      } else {
        var line = {
          nameLine,
          descriptionLine
        };
        store.dispatch("newLine", line).then(() => {
          this.nameLine = "";
          this.descriptionLine = "";
          this.isLoadingLine = false;
          this.modal = false;
        });
      }
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
.prueba-circulo {
  background-image: url("");
  background-repeat: no-repeat;
  width: 200px;
  height: 200px;
  background: #cccccc;
  border-radius: 100%;
  position: relative;
}
.form {
  position: relative;
  bottom: 80px;
}
</style>